import { createSlice } from '@reduxjs/toolkit';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PostManagement } from '../Api/PostManagement';


export const fetchUserPostThunk = createAsyncThunk(
    'userPost/fetch',
    async (_, { getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await PostManagement.fetch({ api_token });
            return response.data
        } catch (err) {
            return Promise.reject(err);
        }
    }
)

export const deleteUserPostThunk = createAsyncThunk(
    'userPost/delete',
    async ({ post_slug, setUserPostList }, { dispatch, getState }) => {
        try {
            const { api_token } = getState().profile.data;
            const response = await PostManagement.delete({ post_slug, api_token });
            setUserPostList(prev => {
                return [
                    ...prev.map(tracks => {
                        if (tracks.post_slug != post_slug)
                            return {
                                ...tracks
                            };
                    })
                ].filter(Boolean);
            }
            )
            dispatch(removePost({ post_slug }));
            return response.data
        } catch (err) {
        }
    }
)

const initialState = {
    status: "pending",
    data: [],
}

export const postManagementSlice = createSlice({
    name: 'postManagement',
    initialState,
    reducers: {
        setStatus: (state, actions) => {
            return {
                ...state,
                ...actions.payload
            }
        },
        resetState: () => {
            return initialState
        },
        removePost: (state, actions) => {
            const list = {
                ...state,
                data: [...state.data.map(item => {
                    return {
                        ...item,
                        post_list: [...item.post_list.map(tracks => {
                            if (tracks.post_slug != actions.payload.post_slug)
                                return {
                                    ...tracks
                                };
                        })].filter(Boolean)
                    }


                })]
            }
            return list;

        }
    },
    extraReducers: {
        [fetchUserPostThunk.fulfilled]: (state, action) => {
            state.data = action.payload
            state.status = "success"
        },
        [fetchUserPostThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [fetchUserPostThunk.rejected]: (state, action) => {
            state.status = "error"
        },
        [deleteUserPostThunk.fulfilled]: (state, action) => {
            state.status = "success"
        },
        [deleteUserPostThunk.pending]: (state, action) => {
            state.status = "loading"
        },
        [deleteUserPostThunk.rejected]: (state, action) => {
            state.status = "error"
        },
    }
})


// Action creators are generated for each case reducer function
export const { setStatus, removePost,resetState } = postManagementSlice.actions

export default postManagementSlice.reducer